var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fill 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "EY_Styles",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "EY_CTAs_Desktop-and-Tablet",
    transform: "translate(-1212.000000, -3089.000000)",
    fill: "#2E2E38"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-Light-BG",
    transform: "translate(790.000000, 3012.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "default",
    transform: "translate(84.000000, 63.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Facebook-Light-BG",
    transform: "translate(324.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.0617022,14 L14.9382341,14 C14.4200079,14 14,14.4200079 14,14.9382341 L14,30.0617022 C14,30.5798647 14.4200079,31 14.9382341,31 L23.0802338,31 L23.0802338,24.416692 L20.8647783,24.416692 L20.8647783,21.8510388 L23.0802338,21.8510388 L23.0802338,19.9589651 C23.0802338,17.7632552 24.421278,16.5676277 26.3800408,16.5676277 C27.3183387,16.5676277 28.1247232,16.6374379 28.3596958,16.6686487 L28.3596958,18.9633414 L27.001199,18.9639783 C25.9359561,18.9639783 25.7296465,19.4701662 25.7296465,20.2129826 L25.7296465,21.8510388 L28.2702673,21.8510388 L27.9394968,24.416692 L25.7296465,24.416692 L25.7296465,31 L30.0617022,31 C30.5798647,31 30.9999363,30.5798647 30.9999363,30.0617022 L30.9999363,14.9382341 C30.9999363,14.4200079 30.5798647,14 30.0617022,14",
    id: "Fill-1"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFacebook);
export default __webpack_public_path__ + "static/media/ic_facebook.11129e728672cb646cc5f673b909520a.svg";
export { ForwardRef as ReactComponent };